import {default as DiaChartMapperAbstract, DiaChartMapperInterface, type ApexOptions } from "@dia-ui/bundle/dist/collection/components/chart/src/libs/DiaChartMapperAbstract";

export default class DiaChartMapperInfluxClientData extends DiaChartMapperAbstract implements DiaChartMapperInterface {
  /**
   * constructor
   * @param data
   */
  // eslint-disable-next-line
  constructor(data: any) {
    super(data);
  }

  /**
   * map custom data to apex chart series format
   * @param data
   */
  seriesMapper(data: any): ApexOptions['series'] {
    if (data.data.results && data.data.results[0]) {
      let seriesArray = data.data.results[0]?.series || [],
        _seriesResult: any = [];

      seriesArray.forEach((series) => {
        _seriesResult.push({
          name: series.tags.client_id,
          data: series.values.map((entry: any) => {
            return {
              x: entry[0],
              y: entry[1] || 0
            }
          })
        });
      });

      return _seriesResult;
    }
  }

  /**
   * getSeries
   */
  getSeries(): ApexOptions['series'] {
    return super.getSeries();
  }
}

export {
  ApexOptions
}
